export interface TextChunk {
  text: string;
  baseOffset: number;
}

function computeBreakPoints(text: string): number[] {
  const breaks = new Set<number>();

  for (let i = 0; i < text.length; i++) {
    if (text[i] === '\n') {
      breaks.add(i + 1);
    }
  }

  const sentenceEnd = /[.!?]\s/g;
  let match: RegExpExecArray | null;
  while ((match = sentenceEnd.exec(text)) !== null) {
    breaks.add(match.index + 2);
  }

  breaks.add(text.length);
  return Array.from(breaks).sort((a, b) => a - b);
}

export function splitText(
  text: string,
  maxChars: number,
  overlap: number = 0
): TextChunk[] {
  if (text.length <= maxChars) {
    return [{ text, baseOffset: 0 }];
  }

  const breaks = computeBreakPoints(text);
  const chunks: TextChunk[] = [];
  let start = 0;

  while (start < text.length) {
    const budgetEnd = start + maxChars;

    let end = -1;
    for (const b of breaks) {
      if (b > start && b <= budgetEnd) {
        end = b;
      } else if (b > budgetEnd) {
        break;
      }
    }

    if (end === -1) {
      end = budgetEnd;
    }

    chunks.push({ text: text.slice(start, end), baseOffset: start });

    if (end >= text.length) {
      break;
    }

    start = overlap > 0 ? Math.max(end - overlap, start + 1) : end;
  }

  return chunks;
}
